// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1qQCA","title":"InfoRow_title__2yWjw"};